import { defineNuxtPlugin } from 'nuxt/app';

/**
 * Notifies Cypress when Nuxt hydration is complete.
 * This plugin only runs on the client-side and sets a window flag
 * that Cypress tests can wait for to ensure the app is fully hydrated
 * before interacting with it.
 */
export default defineNuxtPlugin({
	name: 'hydration-completed-notification',
	setup: (nuxtApp) => {
		nuxtApp.hooks.hook('app:suspense:resolve', () => {
			// Mark hydration as complete on the window object
			(window as any).__omniSearchHydrated__ = true;
		});
	}
});
